import { useState } from "react";
import { loginUser } from "../services/authService";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false); // 1. Add loading state

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");          // Clear any previous errors on new attempt
    setIsLoading(true);    // 2. Start loading

    try {
      await loginUser(email, password);
      window.location.reload();
    } catch {
      setError("Invalid credentials");
      setIsLoading(false); // 3. Stop loading only if it fails (if it succeeds, the page reloads)
    }
  };

  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading} // 4. Disable inputs while loading
            required
          />
        </div>
        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading} // 4. Disable inputs while loading
            required
          />
        </div>
        
        {/* 5. Dynamically change button content and disable it */}
        <button 
          type="submit" 
          className="btn btn-primary w-100" 
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Logging in...
            </>
          ) : (
            "Login"
          )}
        </button>
      </form>
    </>
  );
}